module.exports = __webpack_public_path__ + "static/media/sow-sectio-3shape.5c49bb54.svg";